import { ExternalDBOverview, InternalDBOverview } from '../utils/models';
import httpService from './httpService';

class DashboardService {
	getInternalDashboard() {
		return httpService.get<InternalDBOverview>('/dashboard/internal').then(response => response.data);
	}

	getExternalDashboard() {
		return httpService.get<ExternalDBOverview>('/dashboard/customer').then(response => response.data);
	}
}

const dbService =  new DashboardService();
export default dbService;
